import React, { Component } from 'react';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import cloneDeep from 'lodash/cloneDeep';
import { Switch } from 'antd';

export default class SwitchLuxuryStateButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicle: props.row,
      check: props.row.vhc_luxury,
    };
  }

  handle = async (checked) => {
    this.setState({ check: checked });
    const updateModel = cloneDeep(this.props.row);
    updateModel.vhc_luxury = checked;
    var value = await VehicleApi.editCar(updateModel);
    if (!value || value['message']) {
      NotifyAlert('Lỗi', 'Không thể thay đổi trạng thái xe!');
    }
  };

  render() {
    return (
      <div
        style={{
          display: 'block',
          marginLeft: '25px',
        }}
      >
        <label className="lable-option" style={{ margin: '0px' }}>
          <Switch onChange={this.handle} defaultChecked={this.state.check} />
        </label>
      </div>
    );
  }
}
